import { Spinner, SpinnerSize } from '@blueprintjs/core';
import React from 'react';
import { getIntentClassName } from 'vet-bones/utils';

import { FormAction } from 'src/ui/components/FormActions';

export const makeSubmitAction = (
  text: string,
  working: boolean
): FormAction => {
  return {
    className: getIntentClassName('sd-green'),
    icon: working ? <Spinner size={SpinnerSize.SMALL} /> : undefined,
    isSubmit: true,
    text,
  };
};
